define(function() {
  'use strict';

  return function(options, popup) {
    const popupButtonSelector = '.popup-trigger';

    class Popup {
      constructor(popup) {
        this.active       = 'popup--active';
        this.body         = document.querySelector('body');
        this.popup        = popup;
        this.screenXL     = window.matchMedia('screen and (min-width: 1200px)');
        this.popupId      = popup.dataset.popup;
        this.buttons      = [...document.querySelectorAll(`${popupButtonSelector}[data-popuptrigger=${this.popupId}]`)];
        this.popupContent = this.popup.querySelector('.popup__content');
        this.closeButton  = this.popup.querySelector('.popup__close-button');
        this.triggerActive = 'popup-trigger--active';
        this.widnowWidth = window.innerWidth;
        this.triggeredButton;

        this.buttons.forEach(button => {
          button.addEventListener('click', (e) => {
            this.triggeredButton = (e.target.classList.contains('button')) ? e.target : e.target.parentNode;
            this.toggle();
          });
        });

        if (this.closeButton) {
          this.closeButton.addEventListener('click', () => {
            this.hide();
          });
        }

        window.addEventListener('click', (e) => {
          if (
            (!this.popup.contains(e.target)) &&
            (!this.hasTrigger(this.buttons, e.target))
          ) {
            if (this.isActive()) {
              this.hide();
            }
          }
        });

        if (this.popupId === 'sort-popup') {
          window.addEventListener('resize', () => {
            // fix for chrome mobile
            if (this.widnowWidth !== window.innerWidth) {
              this.sortRole();
            }
          });
          this.sortRole();
        }

        if (this.popupId === 'sidebar-popup') {
          window.addEventListener('resize', () => {
            // fix for chrome mobile
            if (this.widnowWidth !== window.innerWidth) {
              this.sidebarRole();
            }
          });
          this.sidebarRole();
        }
      }

      hasTrigger(arr, target) {
        let containsTarget = false;
        arr.forEach(item => {
          if (item.contains(target)) {
            containsTarget = true;
          }
        });
        return containsTarget;
      }

      toggle() {
        if (this.isActive()) {
          this.hide();
        }
        else {
          this.show();
        }
      }

      show() {
        this.popup.classList.add(this.active);
        this.popup.setAttribute('aria-hidden', 'false');
        this.popupContent.focus();
        window.addEventListener('keydown', this.keyboardClosePopup.bind(this));
        if (this.triggeredButton !== undefined) {
          this.triggeredButton.classList.add(this.triggerActive);
        }
      }

      hide() {
        this.popup.classList.remove(this.active);
        this.popup.setAttribute('aria-hidden', 'true');
        if (this.triggeredButton !== undefined) {
          this.triggeredButton.classList.remove(this.triggerActive);
          this.triggeredButton.focus();
        }
      }

      isActive() {
        return this.popup.classList.contains(this.active);
      }

      keyboardClosePopup(event) {
        if (event.which === 27) {
          if (this.isActive()) {
            this.hide();
          }
        }
      }

      sidebarRole() {
        if (this.screenXL.matches) {
          this.popup.setAttribute('role', 'navigation');
          this.show();
        }
        else {
          this.popup.setAttribute('role', 'dialog');
          this.hide();
        }
      }

      sortRole() {
        this.hide();
      }
    }

    new Popup(popup);
  };
});
